export default __webpack_public_path__ + "static/media/biomass-liquid-icon.714a6f82.svg";